<template>
    <div class="footer-container">
        <div class="footer-info">
            <h1 class="site-title">
                <span class="deep-blue-font">D</span>
                <span class="blue-font">I</span>
                <!-- black -->
                 <!-- <span class="black-font">RC</span> -->
                <span>RC Research Center</span>
            </h1>
            <p class="site-description">
                {{ lang === 'zh-cn' ? '中心联系：王新兵' : 'Contact: Xinbing Wang' }}
            </p>
            <!-- <p class="site-description">
                {{ lang === 'zh-cn' ? '网站建设：Acemap工作组' : 'Created: Acemap' }}
            </p> -->
        </div>
        <div class="footer-copy">
            © Copyright 2013-2026 DIRC, Shanghai Jiao Tong University. 
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        lang() {
            return this.$store.state.lang;
        },
    },
}
</script>
<style lang="less" scoped>
.footer-info {
    padding: 32px;
    background: #3a3a3a;
    color: #fff;
    text-align: center;
    .site-title {
        font-size: 30px;
        font-weight: 800;
        margin-bottom: 16px;
    }
    .site-description {
        font-size: 14px;
        font-weight: 400;
        margin: 8px 0;
    }
    .blue-font {
        color: #00B0F0;
    }
    .deep-blue-font {
        color: #0370BF;
    }
    .black-font {
        color: #000;
    }
}
.footer-copy {
    background: #2B2B2B;
    text-align: center;
    padding: 16px;
    color: #fff;
}
</style>